import { call, put, takeEvery } from "redux-saga/effects";
import {
  deleteInterviews,
  getInterviewCountDetails,
  getCounts,
  getListing,
  createInterviewCustomView,
  getAllInterviewCustomView,
  selectInterviewCustomView,
  deleteInterviewCustomView,
  getInterviewCustomViewById,
  editInterviewCustomViewById,
  unselectAllCustomView,
  cancelInterview,
  addInterviewLogs,
  completeInterview,
  createInterview,
  rescheduleInterview,
  uploadInterviewAttachment,
  fetchInterviewByMultiIds,
} from "../../helpers/backend_helper";
import {
  fetchInterviewCountsSuccess,
  fetchInterviewCountsFailure,
  fetchInterviewListingDetailsSuccess,
  fetchInterviewListingDetailsFailure,
  deleteInterviewsSuccess,
  deleteInterviewFailure,
  createInterviewCustomViewSuccess,
  createInterviewCustomViewFailure,
  fetchInterviewCustomViewSuccess,
  fetchInterviewCustomViewFailure,
  selectInterviewCustomViewSuccess,
  selectInterviewCustomViewFailure,
  fetchInterviewCustomView,
  deleteInterviewCustomViewSuccess,
  deleteInterviewCustomViewFailure,
  fetchInterviewCustomViewByIdSuccess,
  fetchInterviewCustomViewByIdFailure,
  editInterviewCustomViewByIdSuccess,
  editInterviewCustomViewByIdFailure,
  unselectInterviewCustomViewSuccess,
  unselectInterviewCustomViewFailure,
  rescheduleInterviewSuccess,
  rescheduleInterviewFailure,
} from "./action";

import {
  FETCH_INTERVIEW_COUNT_REQUEST,
  FETCH_INTERVIEW_LISTING_REQUEST,
  DELETE_INTERVIEWS_REQUEST,
  CREATE_INTERVIEW_CUSTOM_VIEW,
  FETCH_INTERVIEW_CUSTOM_VIEW,
  SELECT_INTERVIEW_CUSTOM_VIEW,
  DELETE_INTERVIEW_CUSTOM_VIEW,
  FETCH_INTERVIEW_CUSTOM_VIEW_BY_ID,
  EDIT_INTERVIEW_CUSTOM_VIEW_BY_ID,
  UNSELECT_INTERVIEW_CUSTOM_VIEW,
  CREATE_INTERVIEW_REQUEST,
  TRAIN_CREATE_INTERVIEW_REQUEST,
  RESCHEDULE_INTERVIEW_REQUEST,
  TRAIN_CANCEL_INTERVIEW_REQUEST,
  TRAIN_RESCHEDULE_INTERVIEW_REQUEST,
  UPLOAD_INTERVIEW_ATTACHMENT_REQUEST,
} from "./actionType";

import {
  cancelInterviewSuccess,
  cancelInterviewFailure,
  addInterviewLogsSuccess,
  addInterviewLogsFailure,
  completeInterviewSuccess,
  completeInterviewFailure,
  createInterviewSuccess,
  createInterviewFailure,
  trainCreateInterviewSuccess,
  trainCreateInterviewFailure,
  trainCancelInterviewSuccess,
  trainCancelInterviewFailure,
  trainRescheduleInterviewSuccess,
  trainRescheduleInterviewFailure,
  uploadInterviewAttachmentSuccess,
  uploadInterviewAttachmentFailure,
  fetchInterviewByMultiIdsSuccess,
  fetchInterviewByMultiIdsFailure,
} from "./action";

import {
  tagJobWithAttachments,
  tagJob,
} from "@workspace/job/src/helpers/backend_helper";

import {
  tagJobAttachmentFailure,
  tagJobAttachmentSuccess,
  tagJobFailure,
  tagJobSuccess,
} from "@workspace/job/src/store/actions";

import {
  CANCEL_INTERVIEW_REQUEST,
  ADD_INTERVIEW_LOGS_REQUEST,
  COMPLETE_INTERVIEW_REQUEST,
  FETCH_INTERVIEW_BY_MULTI_IDS_REQUEST,
} from "./actionType";

import { fetchUpcomingInterviewsRequest } from "../DailyInterviews/action";
import { toast } from "react-toastify";

function* fetchInterviewCountSaga(action) {
  try {
    const response = yield call(getCounts, action.payload);
    yield put(fetchInterviewCountsSuccess(response));
  } catch (error) {
    yield put(fetchInterviewCountsFailure(error.message));
  }
}

function* fetchInterviewListingSaga(action) {
  try {
    const response = yield call(getListing, action.payload);
    yield put(fetchInterviewListingDetailsSuccess(response));
  } catch (error) {
    yield put(fetchInterviewListingDetailsFailure(error.message));
  }
}

function* deleteInterviewSaga(action) {
  try {
    const response = yield call(deleteInterviews, action.payload);
    yield put(deleteInterviewsSuccess(action.payload));
    toast.success("Interview deleted successfully");
  } catch (error) {
    yield put(deleteInterviewFailure(error.message));
  }
}
//Fetch Interview Custom Views
function* workFetchInterviewCustomView() {
  try {
    const response = yield call(getAllInterviewCustomView);
    yield put(fetchInterviewCustomViewSuccess(response.data));
  } catch (error) {
    yield put(fetchInterviewCustomViewFailure(error));
  }
}
//Create Interview Custom View
function* workCreateInterviewCustomView(action) {
  const { payload, navigate, closeFilter } = action.payload;
  try {
    const interviewCustomViewResponse = yield call(
      createInterviewCustomView,
      payload
    );
    yield put(createInterviewCustomViewSuccess(interviewCustomViewResponse));
    if (closeFilter) {
      yield put(fetchInterviewCustomView());
      toast.success("Interview custom view created successfully!");
      closeFilter();
    } else {
      navigate("/interview");
    }
  } catch (error) {
    yield put(createInterviewCustomViewFailure(error));
    if (error?.code === 409) {
      toast.error("Interview custom view name already exists.");
    } else {
      toast.error("Error creating interview custom view!");
    }
  }
}
// Select Interview Custom View
function* workSelectInterviewCustomView(action) {
  const { id } = action.payload;
  try {
    const response = yield call(selectInterviewCustomView, id);
    yield put(selectInterviewCustomViewSuccess(response.data));
    yield put(fetchInterviewCustomView());
    toast.success("Interview custom view selected successfully!");
  } catch (error) {
    yield put(selectInterviewCustomViewFailure(error));
    toast.error("Error selecting interview custom view!");
  }
}

// Delete Interview Custom View
function* workDeleteInterviewCustomView(action) {
  const { id } = action.payload;
  try {
    const response = yield call(deleteInterviewCustomView, id);
    yield put(deleteInterviewCustomViewSuccess(response.data));
    yield put(fetchInterviewCustomView());
    toast.success("Interview custom view deleted successfully!");
  } catch (error) {
    yield put(deleteInterviewCustomViewFailure(error));
    toast.error("Error deleting interview custom view!");
  }
}
// Fetch Interview Custom View By Id
function* workFetchInterviewCustomViewById(action) {
  try {
    const response = yield call(getInterviewCustomViewById, action.payload);
    yield put(fetchInterviewCustomViewByIdSuccess(response.data));
  } catch (error) {
    yield put(fetchInterviewCustomViewByIdFailure(error));
  }
}
//Edit Interview Custom View by Id
function* workEditInterviewCustomViewById(action) {
  const { editId, payload, navigate, closeFilter } = action.payload;
  try {
    const response = yield call(editInterviewCustomViewById, editId, payload);
    yield put(editInterviewCustomViewByIdSuccess(response.data));
    if (closeFilter) {
      yield put(fetchInterviewCustomView());
      toast.success("Interview custom view updated successfully!");
      closeFilter();
    } else {
      navigate("/interview");
    }
  } catch (error) {
    yield put(editInterviewCustomViewByIdFailure(error));
    if (error?.code === 409) {
      toast.error("Interview custom view name already exists.");
    } else {
      toast.error("Error updating interview custom view!");
    }
  }
}
//Unselect All Interview Custom View
function* workUnselectInterviewCustomView() {
  try {
    yield call(unselectAllCustomView);
    yield put(unselectInterviewCustomViewSuccess());
    toast.success("Interview default custom view selected");
  } catch (error) {
    yield put(unselectInterviewCustomViewFailure(error));
    toast.error("Error unselecting interview custom view!");
  }
}
function* cancelInterviewSaga(action) {
  try {
    const { interview, date, setRefreshKey } = action.payload;
    const response = yield call(cancelInterview, interview);
    yield put(cancelInterviewSuccess(response.interview, interviewId));
    yield put(fetchUpcomingInterviewsRequest(date));
    setRefreshKey((prev) => prev + 1);
    toast.success("Interview cancelled successfully");
  } catch (error) {
    yield put(cancelInterviewFailure(error.message));
  }
}

function* addInterviewLogsSaga(action) {
  try {
    const { interview, setRefreshKey } = action.payload;
    const response = yield call(addInterviewLogs, interview);
    yield put(addInterviewLogsSuccess(response.interview));
    setRefreshKey((prev) => prev + 1);
    toast.success("Interview logs added successfully");
  } catch (error) {
    yield put(addInterviewLogsFailure(error.message));
  }
}

function* completeInterviewSaga(action) {
  try {
    const { interviewId, interview } = action.payload;
    const response = yield call(completeInterview, interviewId, interview);
    yield put(completeInterviewSuccess(response.interview));
    toast.success("Interview completed successfully");
  } catch (error) {
    yield put(completeInterviewFailure(error.message));
  }
}

function* createInterviewSaga(action) {
  try {
    const response = yield call(createInterview, action.payload);
    yield put(createInterviewSuccess(response.interview));
    toast.success("Interview created successfully");
  } catch (error) {
    yield put(createInterviewFailure(error.message));
  }
}

function* trainCreateInterviewSaga(action) {
  try {
    //Call the tag job attachment logic
    const tagJobAttachmentResponse = yield call(
      tagJobWithAttachments,
      action.attachmentPayload.formData,
      action.attachmentPayload.config
    );
    yield put(tagJobAttachmentSuccess(tagJobAttachmentResponse));

    //Call the create interview saga logic
    const interviewResponse = yield call(
      createInterview,
      action.interviewPayload.formData,
      action.interviewPayload.config
    );

    yield put(createInterviewSuccess(interviewResponse));
    // If both succeed, dispatch the combined success action
    yield put(
      trainCreateInterviewSuccess({
        interviewResponse,
        tagJobAttachmentResponse,
      })
    );
    toast.success("Interview Scheduled successfully");
    action.setRefreshKey((prev) => prev + 1);
  } catch (error) {
    // Dispatch failure actions for both processes
    yield put(createInterviewFailure(error.message));
    yield put(tagJobAttachmentFailure(error.message));

    // Dispatch the combined failure action
    yield put(trainCreateInterviewFailure(error.message));
  }
}

function* rescheduleInterviewSaga(action) {
  try {
    const { interview, setRefreshKey } = action.payload;
    const response = yield call(rescheduleInterview, interview);
    yield put(rescheduleInterviewSuccess(response.interview));
    toast.success("Interview rescheduled successfully");
    if (setRefreshKey) {
      setRefreshKey((prev) => prev + 1);
    }
  } catch (error) {
    yield put(rescheduleInterviewFailure(error.message));
  }
}

function* trainCancelInterviewSaga(action) {
  try {
    const tagJobResponse = yield call(tagJob, action.timeLinePayload);
    yield put(tagJobSuccess(tagJobResponse));

    const { interviewFormData, date, setRefreshKey } = action.interviewPayload;
    const interviewResponse = yield call(cancelInterview, interviewFormData);
    yield put(cancelInterviewSuccess(interviewResponse));
    if (date != null && setRefreshKey != null) {
      yield put(fetchUpcomingInterviewsRequest(date));
      setRefreshKey((prev) => prev + 1);
    }

    yield put(
      trainCancelInterviewSuccess({
        tagJobResponse,
        interviewResponse,
      })
    );
    toast.success("Interview cancelled successfully");
  } catch (error) {
    yield put(trainCancelInterviewFailure(error.message));
    toast.error(error.message);
  }
}

function* trainRescheduleInterviewSaga(action) {
  try {
    const tagJobAttachmentResponse = yield call(
      tagJobWithAttachments,
      action.attachmentPayload.formData,
      action.attachmentPayload.config
    );
    yield put(tagJobAttachmentSuccess(tagJobAttachmentResponse));

    const { interview, setRefreshKey } = action.reschedulePayload;
    const interviewResponse = yield call(rescheduleInterview, interview);
    yield put(rescheduleInterviewSuccess(interviewResponse));
    if (setRefreshKey != null) {
      setRefreshKey((prev) => prev + 1);
    }

    yield put(
      trainRescheduleInterviewSuccess({
        tagJobAttachmentResponse,
        interviewResponse,
      })
    );
    toast.success("Interview reschedule successfully!");
  } catch (error) {
    yield put(trainRescheduleInterviewFailure(error.message));
  }
}

function* interviewAttachmentUploadSaga(action) {
  const { formData, config } = action.attachmentFormData;
  try {
    const response = yield call(uploadInterviewAttachment, formData, config);
    yield put(uploadInterviewAttachmentSuccess(response));
  } catch (error) {
    yield put(uploadInterviewAttachmentFailure(error.message));
  }
}

function* fetchInterviewByMultiIdsSaga(action) {
  try {
    const response = yield call(fetchInterviewByMultiIds, action.payload);
    yield put(fetchInterviewByMultiIdsSuccess(response));
  } catch (error) {
    yield put(fetchInterviewByMultiIdsFailure(error.message));
  }
}

export default function* watchFetchInterviewDetailsSaga() {
  yield takeEvery(DELETE_INTERVIEWS_REQUEST, deleteInterviewSaga);
  yield takeEvery(FETCH_INTERVIEW_COUNT_REQUEST, fetchInterviewCountSaga);
  yield takeEvery(FETCH_INTERVIEW_LISTING_REQUEST, fetchInterviewListingSaga);
  yield takeEvery(CREATE_INTERVIEW_CUSTOM_VIEW, workCreateInterviewCustomView);
  yield takeEvery(FETCH_INTERVIEW_CUSTOM_VIEW, workFetchInterviewCustomView);
  yield takeEvery(SELECT_INTERVIEW_CUSTOM_VIEW, workSelectInterviewCustomView);
  yield takeEvery(DELETE_INTERVIEW_CUSTOM_VIEW, workDeleteInterviewCustomView);
  yield takeEvery(
    FETCH_INTERVIEW_CUSTOM_VIEW_BY_ID,
    workFetchInterviewCustomViewById
  );
  yield takeEvery(
    EDIT_INTERVIEW_CUSTOM_VIEW_BY_ID,
    workEditInterviewCustomViewById
  );
  yield takeEvery(
    UNSELECT_INTERVIEW_CUSTOM_VIEW,
    workUnselectInterviewCustomView
  );
  // yield takeEvery(FETCH_INTERVIEW_COUNT_AND_DETAILS_REQUEST, fetchInterviewCountAndDetailsSaga);
  yield takeEvery(CANCEL_INTERVIEW_REQUEST, cancelInterviewSaga);
  yield takeEvery(ADD_INTERVIEW_LOGS_REQUEST, addInterviewLogsSaga);
  yield takeEvery(COMPLETE_INTERVIEW_REQUEST, completeInterviewSaga);
  yield takeEvery(CREATE_INTERVIEW_REQUEST, createInterviewSaga);
  yield takeEvery(TRAIN_CREATE_INTERVIEW_REQUEST, trainCreateInterviewSaga);
  yield takeEvery(RESCHEDULE_INTERVIEW_REQUEST, rescheduleInterviewSaga);
  yield takeEvery(TRAIN_CANCEL_INTERVIEW_REQUEST, trainCancelInterviewSaga);
  yield takeEvery(
    TRAIN_RESCHEDULE_INTERVIEW_REQUEST,
    trainRescheduleInterviewSaga
  );
  yield takeEvery(
    UPLOAD_INTERVIEW_ATTACHMENT_REQUEST,
    interviewAttachmentUploadSaga
  );
  yield takeEvery(
    FETCH_INTERVIEW_BY_MULTI_IDS_REQUEST,
    fetchInterviewByMultiIdsSaga
  );
}
